//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { CircularProgress } from "@material-ui/core";
import PhoneInput from "react-phone-number-input/input";
import TextField from "@material-ui/core/TextField";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import refresh_token from "../../Global/refresh_token";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import MiddleHeader from '../middleHeader/middleHeader'
import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import { country_list } from "../../Global/country";

//Custom Css + Images
import "./company.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import DeleteG from "../../Assets/deleteG.png";
import EditG from "../../Assets/editG.png";
import help from '../../Assets/help_icon.png';
import helpAr from '../../Assets/help_icon_ar.png';


//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";
import { addCompanyArr } from "../../Redux/Actions/companyArrActions";
import { addCompany } from "../../Redux/Actions/companyAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
   table: {
    minWidth: 950,
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "7px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: `green !important`,
    },
  },
}));

//Main Function
function Company({isOnboarding=false}) {
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const [packageCurrentDetails, setPackageCurrentDetails] = useState({});
  const [packageExpired, setPackageExpired] = useState(false);
  const [currentCompany, setCurrentCompany] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companiesArr, setCompaniesArr] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [signatureUrl, setSignatureUrl] = useState("");
  const [userData, setUserData] = useState("");
  const [token, setToken] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [currentEditCompany, setCurrentEditCompany] = useState("");
  const [teams, setTeams] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const history = useHistory();
  const [companyData, setCompanyData] = useState({
    company_name: "",
    short_name: "",
    country: "",
    email: "",
    logo:null,
  });
  let [errorObj, setErrorObj] = useState({
    company_name: "",
    short_name: "",
    country: "",
    email: "",
  });

  const dispatch = useDispatch();

  function handleInputChange(event) {
    let { name, value } = event.target;
    setCompanyData({
      ...companyData,
      [name]: value,
    });
  }

  console.log("permissions_obj ))))))))))))))))))))))))",permissions_obj)
  function handlePhoneInputChange(value) {
    setCompanyData({
      ...companyData,
      phone: value,
    });
  }

  const handleCancel = () => {
    setEditMode(false);
    setCompanyData({
      company_name: "",
      short_name: "",
      country: "",
      email: "",
    });
    setPhoneNumber("")
    setErrorObj({
    company_name: "",
    short_name: "",
    country: "",
    email: "",
    })
  };


  const onCheckCompany = (value, index) => {
    console.log("Before", companies);
    let _companies = [...companies];
    _companies[index].checked = value;

    console.log("After", _companies);
    setCompanies(_companies);
  };

  const handleStatus = (userId) => {
    console.log("id", userId);
  };

  // async function removeCompany(companyId) {
  //   console.log(companyId);
  //   fetch(GlobalApi + "/company/freeze_company", {
  //     method: "post",
  //     headers: new Headers({
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     }),
  //     body: JSON.stringify({
  //       company_id: companyId,
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then(async (res) => {
  //       console.log("remove user response >>>>", res);
  //       if (res.status === "Success") {
  //         await swal(<>{t("Success")}</>, "Company Removed Successfully", "success");
  //         getCompaniesDetail(token, userData.organization_id, userData);
  //       } else {
  //         alert(res.err);
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // }


  let uploadProfileImage = async (singleFile = null) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    //Check if any file is selected or not
    if (singleFile != null) {
      //If file selected then create FormData
      const fileToUpload = singleFile;
      const data = new FormData();
      data.append("name", fileToUpload.name);
      data.append("company_id", company.id);
      data.append("user_id", data.id);
      data.append("images", fileToUpload);
      try {
        let res = await fetch(GlobalApi + "/user/image_upload", {
          method: "post",
          body: data,
          headers: new Headers({
            Authorization: "Bearer " + token,
            // "Content-Type": "multipart/form-data; ",
          }),
        });
        let responseJson = await res.json();
        if (responseJson.status == "Success") {
          console.log("Image Uploaded>>>>>>>", responseJson);
          setProfileImageUrl(responseJson.data);
          setCompanyData({
            ...companyData,
            logo: responseJson.data,
          });
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("Please Select File first");
    }
  };


  const editCompany = (key, companyId) => {
    setEditMode(true);
    setCurrentEditCompany(companyId);
    let currentCompany = companies[key];

    console.log("current Company",currentCompany)
    setCompanyData({
      company_name: currentCompany.company_name,
      short_name: currentCompany.short_name,
      country: currentCompany.country,
      email: currentCompany.email,
      logo:currentCompany.logo
    });
    setPhoneNumber(currentCompany.phone)
  };

  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data.user_id,
      organization_id:data?.organization_id
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
        
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
        }
      })
      .catch((error) => console.log(error.message));
  }

  const deleteCompany = (key, companyId) => {
    console.log("Company Data>>>>>>>", companiesData);
    swal({
      title: t("Are you sure you want to delete this company?"),
      text: t("All Data Including Media will be permenantly Deleted!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        if (data2?.super_admin == true) {
          let indx = companiesData.findIndex((x) => x.id === data.id);
          console.log("index>>>>>>>>>>>>",indx)
          if (indx > -1) {
            fetch(GlobalApi + "/company/delete_company/" + companyId, {
                  method: "get",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                }).then((response) => response.json())
                  .then(async (res) => {
                console.log("Company Data >>>>", res);
                if (res.msg === "success") {
                  if (data.id === companyId) {
                    let get_master_company = companiesData.findIndex(
                      (x) => x.branch_status === "master"
                    );
    
                    console.log("get_master_company>>>>>>>>>>>>",get_master_company)
                    console.log("companiesData>>>>>>>>>>>>",companiesData)
                    let get_companyId = companiesData[get_master_company];
                    companiesData.splice(indx, 1);
                    swal(t("Success"), t("Company Deleted Successfully"), "success");
                    console.log("companiesData[get_master_company]", get_companyId)
                    dispatch(addCompanyArr(companiesData));
                    dispatch(addCompany(get_companyId));
                    setCompanies(companiesData)
                  } else {              
                    companiesData.splice(indx, 1);        
                    console.log("this Condition ____________________________________",companiesData)
                    swal(t("Success"), t("Company Deleted Successfully"), "success");
                    dispatch(addCompanyArr(companiesData));
                    getCompaniesDetail(data2.token, data2.organization_id, data2)
                  }
                  getFileSize()
                } else if (res.msg === "error") {
                  swal(t("Error"), res.error, "error");
                }
              })
              .catch((err) => {
                swal(t("Error"), err, "error");
              });
          } else {
            alert("Something went wrong....");
          }
        } else {
          let indx = companiesData.findIndex((x) => x.id == companyId);
          console.log("Selected Index", indx);
       
          if (indx > -1) {
            if(companiesData.length == 1){
              swal(t("Error"), t("Atleast One Company Required"), "error");
          }
          else{
            fetch(GlobalApi + "/company/delete_company/" + companyId, {
              method: "get",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
            }).then((response) => response.json())
              .then(async (res) => {
                console.log("Company Data >>>>", res);
                if (res.msg === "success") {
                  getFileSize()
                  console.log("DATA after success",data);
                  console.log("company",companyId)
                   if (data.id == companyId) {
                     console.log("if Condition Executed")
                    companiesData.splice(indx, 1);
                    if (companiesData.length != 0) {
                      let companyID = companiesData[0];
                      console.log("After Deleted Company >>>>>>>", companiesData);
                      swal(t("Success"), t("Company Deleted Successfully"), "success");
                      dispatch(addCompanyArr(companiesData));
                      dispatch(addCompany(companyID));
                    } else {
                      localStorage.clear();
                      history.replace("/signin")
                    }
                  } else {
                    console.log("Else Condition Executed")
                    let NewCompanies = [...companiesData]
                    NewCompanies.splice(indx, 1);
                    console.log("Companies After Deleted",NewCompanies)
                    swal(t("Success"), t("Company Deleted Successfully"), "success");
                    dispatch(addCompanyArr(NewCompanies));
                    setCompanies(NewCompanies)
                  }
                } else if (res.msg === "error") {
                  console.log(res.error);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
        }
    
      } else {
        console.log("Canceled");
      }
    });
    
    // fetch(GlobalApi + "/company/delete_company/" + companyId, {
    //     method: "get",
    //     headers: new Headers({
    //       Authorization: "Bearer " + token,
    //       "Content-Type": "application/json",
    //     }),
    //   }).then((response) => response.json())
    //     .then(async (res) => {
    //       console.log("Delete COMPANY RES>>>>>>>>",res)
    //       if(res.msg === "success") {
    //         swal(<>{t("Success")}</>, <>{t("Company Deleted Successfully")}</>, "success");
    //         getCompaniesDetail(token, userData.organization_id, userData);
    //       } else if(res.msg == "error") {
    //         swal(<>{t("Error")}</>, res.error, "error");
    //       }
    //     }).catch((err) => {
    //       swal(<>{t("Error")}</>, "internal Server Error", "error");
    //     });
  };

  const resetFields = () => {
    setCompanyData({
      company_name: "",
      short_name: "",
      country: "",
      email: "",
    });
    setPhoneNumber('')
  };

    const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);

          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  async function getCompaniesDetail(Token, OrganizationId, UserData) {
    console.log("TOKEN >>>>>>>", Token);
    console.log("ORG ID >>>>>>>", OrganizationId);
    console.log("DATA >>>>>>>", UserData);
    let params1 = {
      organization_id: OrganizationId,
    };
    let query1 = Object.keys(params1)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params1[k]))
      .join("&");

    if (UserData?.super_admin == true) {
      console.log("**************** Under Super Admin Condition .>>>>>>>");
      let getCompanies = await fetch(
        GlobalApi + "/company/companies?" + query1,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Token,
            "Content-Type": "application/json",
          },
        }
      );
      let companiesJson = await getCompanies.json();
      if (companiesJson.msg === "success") {
        console.log("COMPANIES >>>>>>>>>>>>", companiesJson.companies);
        setCompanies(companiesJson.companies);
        dispatch(addCompanyArr(companiesJson.companies));
      }
    }
    
    
    if (UserData.super_admin === false) {
      console.log("COMPANIES >>>>>>>>>>>>", UserData);
      setCompanies(companiesData);
    }

    // else if (userData?.super_admin == false) {
    //   console.log('NOt Super Admin user >>>',)
    //   let getPermissions = await fetch(GlobalApi + '/Permission/get_all_company_permissions?' + query1, {
    //     method: 'GET',
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   let permissionsJson = await getPermissions.json();
    //   console.log('single company >>>>>>', permissionsJson);
    //   if (permissionsJson.status === 'Success') {
    //     // if (handleGlobelCompanies != undefined) {
    //     //   handleGlobelCompanies(permissionsJson.data)
    //     // }
    //     let industry_data = [];
    //     userData.companies.map(v => {
    //       industry_data.push({
    //         label: v.company_name,
    //         value: v.id,
    //       })
    //     })
    //     // let nameComp = reqJsonCompanies.companies[0].id;
    //     // console.log('nameComp >>>>', nameComp);
    //     setCompanies(industry_data);
    //     // setCompanies([{
    //     //    label:reqJsonCompany.company.company_name,
    //     //    value:reqJsonCompany.company.id
    //     // }]);
    //     setCompaniesValue({
    //       ...companiesValue,
    //       main_comp: industry_data[0].value,
    //       super_admin: false
    //     })
    //     if(currentRoute === 'TeamScreen'){
    //       fetchCompanyUsers(industry_data[0].value)
    //     }
    //   }
    // }
  }
  let companiesData = useSelector((state) => state.companyArrReducer.company);
  let data = useSelector((state) => state.companyReducer.company);
  let company = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      setCurrentCompany(data);
      getPermissions();
    },
    [data]
  );

  useEffect(() => {
    getCurrentPackage();
  }, []);

  let data2 = useSelector((state) => state.userReducer.user);

  useEffect(
    () => {
      setUserData(data2);
      setToken(data2.token);
      setOrganizationId(data2.organization_id);
      getCompaniesDetail(data2.token, data2.organization_id, data2);
    },
    [data2]
  );

  let data3 = useSelector((state) => state.teamReducer.team);
  console.log("data3", data3);

  useEffect(
    () => {
      setTeams(data3.data);
    },
    [data3]
  );
  async function getCurrentPackage() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");


    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    let reqJson = await req.json();
    console.log("Calling Get License ", reqJson);

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
      setPackageCurrentDetails("expired");
      setPackageExpired(true)
    } else {
      setPackageCurrentDetails(reqJson.package);
    }
  }



  const handleSubmit = (e) => {
    setBtnLoader(true);
    if (!editMode) {
      let obj = companyData;
      let { company_name, short_name, country, email } = obj;
      console.log("ADD MODE OBJ", obj);
      let errors = {};

      // if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email.replace(' ', '')) === false) {
      //   errors.email = 'Please Enter a Valid Email.';
      // }

      if (company_name.length <= 0) {
        errors.company_name = 'Company Name is required';
      }
      
      if (short_name.length <= 0) {
        errors.short_name = 'Short Name is required';
      }
      if (company_name.length > 100) {
        errors.company_name = 'Company Name Must be less than 100 characters';
      }
      
      if (short_name.length > 50) {
        errors.short_name = 'Short Name Must be less than 50 characters';
      }

      if (!country) {
        errors.country = "Country required"
      }

      setErrorObj(errors);

      if (Object.keys(errors).length !== 0) {
        setBtnLoader(false);
      }


      if (Object.keys(errors).length === 0) {
        console.log("TOKEN >>>>>> ", token);
        console.log("USER DAAT >>>>>> ", userData);
        console.log("USER DAAT >>>>>> ", obj);

      fetch(GlobalApi + "/company/add_company", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          ...obj,
          phone:phoneNumber,
          created_by: userData.user_id,
          organization_id: userData.organization_id,
          // set_password_later: true,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("ADD COMPANY RES>>>>>>>>", res);
          if (res.msg === "success") {
            swal(t("Success"), t("Company Added Successfully"), "success");
            let updatedCompany = [...companiesData]
            updatedCompany.push(res.company)
            console.log("UPDATED COMPANY >>>>>>>>>>>>>>",updatedCompany)
            dispatch(addCompanyArr(updatedCompany));
            setCompanies(updatedCompany);
            resetFields();
            setBtnLoader(false);
          } else {
            console.log(res.error);
            swal(t("Error"), res.error, "error");
            setBtnLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          swal(t("Error"), t("internal Error"), "error");
          setBtnLoader(false);
        });
      }
    } else if (editMode) {
      
      let obj = companyData;
      let { company_name, short_name, country, email } = obj;
      console.log("Edit Mode", obj);
      console.log("current Edit Company", currentEditCompany);

      fetch(GlobalApi + "/company/edit_company/" + currentEditCompany, {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          ...obj,
          phone:phoneNumber,
          created_by: userData.user_id,
          organization_id: userData.organization_id,
          // set_password_later: true,
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("upadated Team Member >>>>", res);
          if (res.msg === "success") {
            swal(t("Success"), t("Company has been updated successfully"), "success");
            setEditMode(false);
            console.log("EDIT MODE >>>>>>>>")
            if(data2.super_admin == true){getCompaniesDetail(data2.token, data2.organization_id, data2);}
            resetFields();
            setBtnLoader(false);
            setEditMode(false);
          } else {
            console.log(res.err);
            swal(t("Error"), t("internal Error"), "error");

            setBtnLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          swal(t("Error"), t("internal Error"), "error");
          setBtnLoader(false);
        });
    }
  };

  const classes = useStyles();
  return <div className={isOnboarding == true ? "scrollHidden" : ""} style={{ width: "100%", padding:isOnboarding == true ? (window.innerWidth > 500 ? "20px 1px 20px 20px" : "10px 1px 10px 10px") : "20px", overflowY: "auto", backgroundColor: Colors.globalColor9 }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding:'20px' }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={12} md={2} lg={2} style={{ textAlign: "center" }}>
          {!packageExpired && (packageCurrentDetails?.package?.title == "Enterprise" || packageCurrentDetails?.package?.title == "Free") ? <>
          {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true ?
            <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={(e) => uploadProfileImage(e.target.files[0])} /> : <input disabled accept="image/*" className={classes.input} id="icon-button-file" type="file"  />}</> :  <>{editMode ? <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={(e) => uploadProfileImage(e.target.files[0])} /> :  <input disabled accept="image/*" className={classes.input} id="icon-button-file" type="file"/>}</>}
            <label htmlFor="icon-button-file">
              <IconButton color="primary" aria-label="upload picture" component="span" style={{ width: "120px", height: "120px", marginTop: "5%", backgroundImage: `url(https://server.uraudits.com/view?Key=${companyData.logo})`, backgroundSize: "cover", backgroundColor: Colors.globalColor5, boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
                <PhotoCamera fontSize="large" style={{ color: !companyData.logo ? "#dee0e1" : "transparent" }} />
              </IconButton>
            </label>  
            <p className="label1Company">{t("Upload Logo")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8} style={{alignItems:'center', justifyContent:'center'}}>
          <Grid container style={{alignItems:'center', justifyContent:'flex-start'}}>
            <p className="label2" style={{ color: Colors.globalColor8, display:'inline', marginTop:0 }}>
              {t("Basic Info")}
            </p>

            

            <Tooltip title={t("Help")}>
               
                <a href="https://www.uraudits.com/knowledge-center/company/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px'}}/>
                  </a>
             
              </Tooltip>
              </Grid>
            <form>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">{t("Company Name")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="company_name" InputProps={{ classes: { input: classes.resize, root: classes.cssOutlinedInput } }} error={errorObj.company_name} helperText={errorObj.company_name} onChange={handleInputChange}  variant="outlined" autoComplete={"off"} size="small" value={companyData.company_name} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">{t("Short Name")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="short_name" InputProps={{ classes: { input: classes.resize } }} error={errorObj.short_name} helperText={errorObj.short_name} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={companyData.short_name} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">{t("Country")}</p>
                      <TextField id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder="Select Business Industry" name="country" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange} helperText={errorObj.country} value={companyData.country} variant="outlined">
                        {country_list.map((item, index) => {
                          return <MenuItem value={item.country} style={{ fontSize: 14 }}>
                              {item.country}
                            </MenuItem>;
                        })}
                      </TextField>
                      {/* <TextField
                      className="inputTextBox"
                      fullWidth
                      id="outlined-basic"
                      name="country"
                      InputProps={{ classes: { input: classes.resize } }}
                      error={errorObj.country}
                      helperText={errorObj.country}
                      onChange={handleInputChange}
                      className={classes.textField}
                      variant="outlined"
                      autoComplete={"off"}
                      size="small"
                      value={companyData.country}
                    /> */}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {/* <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">Email</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="email" InputProps={{ classes: { input: classes.resize } }} error={errorObj.email} helperText={errorObj.email} onChange={handleInputChange}  variant="outlined" autoComplete={"off"} size="small" value={companyData.email} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">Phone</p>
                      <div style={{ border: "1px solid #dadada", borderRadius: "5px", backgroundColor: Colors.globalColor5, width: "100%", height: "35px", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "0px 5px" }}>
                        <PhoneInput className="phoneInp" value={phoneNumber} autoComplete="off" onChange={setPhoneNumber} />
                      </div>

                      
                    </Grid>
                  </Grid> */}
                </Grid>

                <Grid item xs={12} style={{ marginTop: "20px" }}>
                  {!packageExpired && (packageCurrentDetails?.package?.title == "Enterprise" || packageCurrentDetails?.package?.title == "Free") ? <>
                      {" "}
                      {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                          {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {editMode ? <>{t("Update")}</> : <>{t("Add")}</>}
                        </Button> : <Button disabled variant="contained" type="submit" className="addBtn2" component="span">
                          {editMode ? <>{t("Update")}</> : <>{t("Add")}</>}
                        </Button>}
                    </> : <>
                    {editMode ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                          {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {editMode ?<>{t("Update")}</> : <>{t("Add")}</>}
                        </Button> :  <Link to="/update_package">
                      <Button variant="contained" type="submit" className="addBtn" component="span">
                        {t("Upgrade Package")}
                      </Button>
                    </Link>}

                    </>}
                  &nbsp;
                  <Button variant="contained" className="cancelBtn" onClick={() => handleCancel()}>
                    {t("Cancel")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2} style={{ textAlign: "center" }} />
        </Grid>

        <Grid container spacing={3} justifyContent="center" alignItems="center">
        {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
        <Grid item xs={12} sm={12} md={isOnboarding == false ? 10 : 12} lg={isOnboarding == false ? 10 : 12}>
            {window.innerWidth > 500 && <br />}
            {window.innerWidth > 500 && 
            <TableContainer // component={Paper}
              style={{ backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
              <Table style={{ minWidth: 900 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align={language =="ar" ? "right" :"left"}>
                      <p className="label3" style={{margin:0, color: Colors.globalColor8,textTransform:"uppercase" }}>
                        {t("Company Name")}
                      </p>
                    </TableCell>
                    <TableCell align={language =="ar" ? "right" :"left"}>
                      <p className="label3" style={{margin:0, color: Colors.globalColor8,textTransform:"uppercase" }}>
                        {t("Short Name")}
                      </p>
                    </TableCell>
                    {/* <TableCell align="left">
                      <p className="label3" style={{margin:0, color: Colors.globalColor8 }}>
                        EMAILs
                      </p>
                    </TableCell>
                    <TableCell align="left">
                      <p className="label3" style={{ color: Colors.globalColor8 }}>
                        PHONE
                      </p>
                    </TableCell> */}
                    <TableCell align={language =="ar" ? "right" :"left"}>
                      <p className="label3" style={{ color: Colors.globalColor8,textTransform:"uppercase" }}>
                        {t("Country")}
                      </p>
                    </TableCell>
                    {/* <TableCell align="center"> </TableCell> */}
                    <TableCell align="center"> </TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {companies.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 1 },
                      }}
                    >
                      <TableCell align={language =="ar" ? "right" :"left"} padding="normal">
                        <Tooltip
                          title={item.company_name ? item.company_name : " "}
                        >
                          <p style={{margin:0,}}>
                            {item.company_name.slice(0, 10) +
                              (item.company_name.length > 10 ? "..." : "")}
                          </p>
                        </Tooltip>
                      </TableCell>
                      <TableCell align={language =="ar" ? "right" :"left"} padding="none">
                        {item.short_name}
                      </TableCell>
                      {/* <TableCell align="left" padding="none">
                        {item.email}
                      </TableCell>
                      <TableCell align="left" padding="none">
                        {item.phone}
                      </TableCell> */}
                      <TableCell align={language =="ar" ? "right" :"left"} padding="none">
                        {item.country}
                      </TableCell>
                      {/* <TableCell
                      padding="none"
                      align="right"
                      style={{ maxWidth: "100px" }}
                    >
                      <IconButton
                        aria-label="delete"
                        onClick={() => removeCompany(item.id)}
                      >
                        <img src={Delete} alt="delete" />
                        <p className="label1Company" style={{ fontSize: 12 }}>
                          Remove
                        </p>
                      </IconButton>
                    </TableCell> */}
                      <TableCell
                        padding="none"
                        align="center"
                        style={{ maxWidth: "150px" }}
                      >
                        {userData?.super_admin == true ||
                        permissions_obj["Admin"] == true ||
                        permissions_obj["Company Management"] == true ? (
                          <>
                           
                            <IconButton
                              aria-label="delete"
                              onClick={() => deleteCompany(index, item.id)}
                            >
                              <img src={Delete} alt="delete" />
                              <p
                                className="label1Company"
                                style={{margin:0, fontSize: 12 }}
                              >
                                {t("Remove")}
                              </p>
                            </IconButton>
                          </>
                        ) : (
                          <>
                           <IconButton aria-label="delete">
                              <img src={DeleteG} alt="delete" />
                              <p
                                className="label1CompanyD"
                                style={{ fontSize: 12 }}
                              >
                                {t("Remove")}
                              </p>
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        padding="none"
                        align="center"
                        style={{ maxWidth: "150px" }}
                      >
                        {userData?.super_admin == true ||
                        permissions_obj["Admin"] == true ||
                        permissions_obj["Company Management"] == true ? (
                          <>
                            <IconButton
                              aria-label="delete"
                              onClick={() => editCompany(index, item.id)}
                            >
                              <img src={Edit} alt="edit" />
                              <p
                                className="label1Company"
                                style={{margin:0, fontSize: 12 }}
                              >
                                {t("Edit")}
                              </p>
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton aria-label="delete">
                              <img src={EditG} alt="edit" />
                              <p
                                className="label1CompanyD"
                                style={{ fontSize: 12 }}
                              >
                                {t("Edit")}
                              </p>
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>}

            {window.innerWidth <= 500 && 
            <div>
             {companies.map((item, index) => {
               return( <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: "left", height: "220px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
               <div style={{display: "flex", height:"100%", flexDirection: "column", justifyContent: "space-between" }}>
                 <div>
                   <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                     {t("Company Name")}
                   </p>
     
                   <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                   {item.company_name.slice(0, 30) +
                                   (item.company_name.length > 30 ? "..." : "")}
                   </p>
                 </div>
                { item.email && <div>
                   <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                     {t("Email")}
                   </p>
                   <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                   {item.email}
                   </p>
                 </div>}
                { item.phone && <div>
                   <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                     {t("Phone")}{" "}
                   </p>
                   <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                   {item.phone}
                   </p>
                 </div>}
     
                 {item.country && <div>
                   <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                     {t("Country")}{" "}
                   </p>
                   <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                   {item.country}
                   </p>
                 </div>}
               </div>
     
               <div style={{display: "flex", height:"100%", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                {userData?.super_admin == true ||
                        permissions_obj["Admin"] == true ||
                        permissions_obj["Company Management"] == true ? (
                          <>
                           
                            <IconButton
                              aria-label="delete"
                              onClick={() => deleteCompany(index, item.id)}
                            >
                              <img src={Delete} alt="delete" />
                              
                            </IconButton>
                          </>
                        ) : (
                          <>
                           <IconButton aria-label="delete">
                              <img src={DeleteG} alt="delete" />
                             
                            </IconButton>
                          </>
                        )}
                </div>
               
     
              
     
               <div>
               {userData?.super_admin == true ||
                        permissions_obj["Admin"] == true ||
                        permissions_obj["Company Management"] == true ? (
                          <>
                            <IconButton
                              aria-label="delete"
                              onClick={() => editCompany(index, item.id)}
                            >
                              <img src={Edit} alt="edit" />
                              
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton aria-label="delete">
                              <img src={EditG} alt="edit" />
                              
                            </IconButton>
                          </>
                        )}
               </div>
     
               </div>
     
               
             </div>);
             })}
            </div>}
            <br />
            <br />
          </Grid>
          {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
        </Grid>
      </div>

    
    </div>;
}

export default Company;
